import { restClient } from '@/Core'

import { toNode } from '../Helpers/diskResponse'

import type { DiskNode } from '../Contracts/DiskNode'

/** Картка вузла з предками (крихти) і правами: `GET /services/disk/nodes/{uuid}`. */
export const LoadDiskNodeTask = async (uuid: string): Promise<DiskNode> => {
    const response = (await restClient.get(
        `/services/disk/nodes/${encodeURIComponent(uuid)}`,
        {},
        { forceRefresh: true }
    )) as unknown

    return toNode(response)
}
